"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDuplicateFilename = exports.renameFileWithCounter = exports.formatBytes = void 0;
const formatBytes = (bytes, translate) => {
    if (bytes === 0)
        return `0 ${translate("bytes")}`;
    const k = 1000, sizes = [
        bytes > 1 ? translate("bytes") : translate("byte"),
        translate("kiloBytes"),
        translate("megaBytes"),
        translate("gigaBytes"),
        translate("teraBytes"),
    ], 
    // i = the power of 1000 for which 1000^i <= bytes < 1000^(i+1)
    i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + " " + sizes[i];
};
exports.formatBytes = formatBytes;
const renameFileWithCounter = ({ files, fileToRename }) => {
    const hasDuplicateName = files.find((file) => file.name === fileToRename.name);
    if (!hasDuplicateName)
        return fileToRename;
    const duplicateFileName = fileToRename.name.split(".")[0];
    const duplicateFileExtension = fileToRename.name.split(".")[1];
    const fileIndexes = files
        .map((file) => {
        var _a;
        const regexp = new RegExp(`^${duplicateFileName}\\((?<index>\\d+)\\)\\.${duplicateFileExtension}$`);
        const matched = file.name.match(regexp);
        const index = (_a = matched === null || matched === void 0 ? void 0 : matched.groups) === null || _a === void 0 ? void 0 : _a.index;
        return index && parseInt(index);
    })
        .filter(Boolean);
    const sorted = fileIndexes.sort((a, b) => a - b);
    let fileIndex;
    // iterates through the sorted array to find the next available index for renaming a file.
    // It skips over indices that are already taken and assigns the first available index to the fileIndex variable
    for (let i = 0; i <= sorted.length; i++) {
        if (sorted[i] === i + 1) {
            continue;
        }
        fileIndex = i + 1;
        break;
    }
    fileIndex = fileIndex !== null && fileIndex !== void 0 ? fileIndex : sorted.length + 1;
    const newName = `${duplicateFileName}(${fileIndex}).${duplicateFileExtension}`;
    return new File([fileToRename], newName, { type: fileToRename.type });
};
exports.renameFileWithCounter = renameFileWithCounter;
const validateDuplicateFilename = (files, fileToValidate) => {
    const isDuplicate = files.some((file) => file.name === fileToValidate.name);
    return isDuplicate ? (0, exports.renameFileWithCounter)({ files, fileToRename: fileToValidate }) : fileToValidate;
};
exports.validateDuplicateFilename = validateDuplicateFilename;
//# sourceMappingURL=Dropzone.helpers.js.map